import React, { useState, useEffect, useCallback } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Button, Spinner } from "@material-tailwind/react";
import { createUser, scheduleVisit, fetchUserSchedule } from "../services/users"; // Verify these functions are correctly implemented
import { fetchPropertyConfigurations } from "../services/projects"; // Verify this function is correctly implemented
import { useUser } from "../context/UserContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateUser from "../pages/Customers/CreateUser";
import ProgressBar from "./ProgressBar";
import { X } from "lucide-react";
import { CloseButton, OutlineButton, PrimaryButton } from "./Buttons";
import CustomInput from "./CustomInput";
import axiosInstance from "../services/api/axios";
import CustomPhoneInput from "./CustomPhoneNumberInput";
function ScheduleVisit({
    openDialog,
    setOpenDialog,
    flowType = "scheduleVisit",
    selectedProject,
    setSelectedProject,
    onVisitScheduled,
    onRawLeadCreated,
    setNewScheduleVisit,
    newScheduleVisit,
    projects,
    existingUser,
    lead,
}) {

    const [step, setStep] = useState(0);
    const [configs, setConfigs] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const user = useUser();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isPropertyAssigned, setIsPropertyAssigned] = useState(false);

    const stepsForCreateUser = ["User Info", "Visit Details", "Review"];
    const stepsForRegularFlow = ["Visit Details", "Review"];
    const stepsForRawLead = ["Lead Info", "Config Selection", "Visit Details"];

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        mobileNoWa: "",
        mobileNoCalling: "",
        emailId: "",
        address: {
            buildingNo: "",
            streetName1: "",
            streetName2: "",
            city: "",
            district: "",
            pinCode: "",
            state: "",
            country: "",
        },
        gender: "MALE",
        title: "MR",
        dob: new Date().toISOString().split("T")[0],
        preferredDate: "",
        preferredTime: "",
        propertyConfig: "",
        buildingId: "",
        isSecondaryUser: false,
        occupation: "",
        selectedProjects: [], // Array to store multiple selected projects
        walkIn: false,
    });

    const { userInfo } = useUser();
    const occupations = [
        "Engineering",
        "Agriculture",
        "Healthcare",
        "Education",
        "Business",
        "Finance",
        "Technology",
        "Arts",
        "Other",
    ];

    const [customerId, setCustomerId] = useState(null);
    const [projectcustomerid, setprojectcustomerid] = useState(null);
    const [selectedProjectObject, setSelectedProjectObject] = useState(null);
   
    useEffect(() => {
        const fetchBuildings = async () => {
            try {
                let buildingResponse;
                let customerIdToUse;

                if (userInfo?.persona === "CHANNEL_PARTNER") {
                    buildingResponse = await axiosInstance.get("/projects/buildings", {
                        params: {
                            agentId: userInfo?.loginIdentifierDetails?.customerId,
                        },
                    });
                    // Handle paginated response format: { items: [...], total: 1, page: 1, ... }
                    let buildingsData = [];
                    if (buildingResponse?.data?.items && Array.isArray(buildingResponse.data.items)) {
                        buildingsData = buildingResponse.data.items;
                    } else if (buildingResponse?.items && Array.isArray(buildingResponse.items)) {
                        buildingsData = buildingResponse.items;
                    } else if (Array.isArray(buildingResponse?.data)) {
                        buildingsData = buildingResponse.data;
                    } else if (Array.isArray(buildingResponse)) {
                        buildingsData = buildingResponse;
                    }

                    setprojectcustomerid(buildingsData[0]?.constructionLinkedPlan?.project?.customerId);
                    customerIdToUse = buildingsData[0]?.constructionLinkedPlan?.project?.customerId;

                } else {
                    customerIdToUse =
                        userInfo?.loginIdentifierDetails?.customer?.customerId ||
                        userInfo?.loginIdentifierDetails?.customerId;

                    buildingResponse = await axiosInstance.get("/projects/buildings", {
                        params: {
                            customerId: customerIdToUse,
                        },
                    });
                }

                // Handle paginated response format: { items: [...], total: 1, page: 1, ... }
                let buildingsData = [];
                if (buildingResponse?.data?.items && Array.isArray(buildingResponse.data.items)) {
                    buildingsData = buildingResponse.data.items;
                } else if (buildingResponse?.items && Array.isArray(buildingResponse.items)) {
                    buildingsData = buildingResponse.items;
                } else if (Array.isArray(buildingResponse?.data)) {
                    buildingsData = buildingResponse.data;
                } else if (Array.isArray(buildingResponse)) {
                    buildingsData = buildingResponse;
                }
                setBuildings(buildingsData);
                setCustomerId(customerIdToUse);

                if (flowType === "rawLead" && !selectedProject && projects.length > 0) {
                    setSelectedProject(projects[0].projectId);
                    setSelectedProjectObject(projects[0]);
                }

            } catch (error) {
                console.error("Error fetching buildings:", error);
            }
        };

        fetchBuildings();
    }, [userInfo?.loginIdentifierDetails?.customer?.customerId, userInfo?.persona, userInfo?.loginIdentifierDetails?.customerId, flowType, selectedProject, projects]);

    useEffect(() => {
        if (flowType === "rawLead" && selectedProject) {
            fetchBuildingsForProject(selectedProject);
        }
    }, [selectedProject, flowType]);

    const fetchBuildingsForProject = async (projectId) => {
        try {
            const buildingResponse = await axiosInstance.get("/projects/buildings", {
                params: { projectId: Number(projectId) }
            });
            // Handle paginated response format: { items: [...], total: 1, page: 1, ... }
            let buildingsData = [];
            if (buildingResponse?.data?.items && Array.isArray(buildingResponse.data.items)) {
                buildingsData = buildingResponse.data.items;
            } else if (buildingResponse?.items && Array.isArray(buildingResponse.items)) {
                buildingsData = buildingResponse.items;
            } else if (Array.isArray(buildingResponse?.data)) {
                buildingsData = buildingResponse.data;
            } else if (Array.isArray(buildingResponse)) {
                buildingsData = buildingResponse;
            }
            setBuildings(buildingsData);
        } catch (error) {
            console.error("Error fetching buildings for project:", error);
            setBuildings([]);
        }
    };

    useEffect(() => {
        const checkIfPropertyAssigned = async () => {

            if (flowType === "scheduleVisit" && existingUser?.userId) {
                try {

                    setIsPropertyAssigned(lead?.user_account?.propertyConfig?.propertyConfigId
                        ? true : false);

                } catch (error) {
                    console.error("Error checking property assignment:", error);
                    setIsPropertyAssigned(false);
                }
            } else {
                setIsPropertyAssigned(false);
            }
        };

        checkIfPropertyAssigned();
    }, [flowType, existingUser]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        // Validate date if it's preferredDate and a value is provided
        if (name === "preferredDate" && value) {
            const selectedDate = new Date(value);
            const today = new Date();
            const maxDate = new Date();
            maxDate.setDate(today.getDate() + 14);
            
            // Reset time to compare only dates
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);
            maxDate.setHours(0, 0, 0, 0);
            
            if (selectedDate < today) {
                toast.error("Please select today's date or a future date.", {
                    position: "top-right",
                    autoClose: 3000,
                });
                return;
            }
            
            if (selectedDate > maxDate) {
                toast.error("Please select a date within the next 14 days.", {
                    position: "top-right",
                    autoClose: 3000,
                });
                return;
            }
        }
        
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleRawLeadInputChange = (e) => {
        const { name, value } = e.target;
        
        // Validate date if it's preferredDate and a value is provided
        if (name === "preferredDate" && value) {
            const selectedDate = new Date(value);
            const today = new Date();
            const maxDate = new Date();
            maxDate.setDate(today.getDate() + 14);
            
            // Reset time to compare only dates
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);
            maxDate.setHours(0, 0, 0, 0);
            
            if (selectedDate < today) {
                toast.error("Please select today's date or a future date.", {
                    position: "top-right",
                    autoClose: 3000,
                });
                return;
            }
            
            if (selectedDate > maxDate) {
                toast.error("Please select a date within the next 14 days.", {
                    position: "top-right",
                    autoClose: 3000,
                });
                return;
            }
        }
        
        setNewScheduleVisit((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleBuildingAndConfigChange = (e) => {
        const { name, value } = e.target;
        //.log("Selected config value:", value); // Add this log
        if (flowType === "scheduleVisit" || flowType === "createUser") {
            setFormData((prev) => ({ ...prev, [name]: value }));
        } else {
            setNewScheduleVisit((prev) => ({ ...prev, [name]: value }));
        }
    };
    const handleWalkInToggle = (checked) => {
        if (flowType === "rawLead") {
            if (typeof setNewScheduleVisit === "function") {
                setNewScheduleVisit((prev) => ({
                    ...prev,
                    walkIn: checked,
                    ...(checked ? { preferredDate: "", preferredTime: "" } : {}),
                }));
            }
        } else {
            setFormData((prev) => ({
                ...prev,
                walkIn: checked,
                ...(checked ? { preferredDate: "", preferredTime: "" } : {}),
            }));
        }
    };
    const fetchConfigs = useCallback(
        async () => {
            try {
                setLoading(true);
    
                let projectId = null;
                let customerId = null;
    
                // Check if we have an existing user with a project ID
                if (lead?.user_account?.project?.projectId) {
                    projectId = lead.user_account.project.projectId;
                } else if (selectedProject) {
                    projectId = selectedProject;
                }
    
                // Get customerId from user context if available
                if (user?.userInfo?.loginIdentifierDetails?.customer?.customerId) {
                    customerId = user.userInfo.loginIdentifierDetails.customer.customerId;
                } else if (user?.userInfo?.loginIdentifierDetails?.customerId) {
                    customerId = user.userInfo.loginIdentifierDetails.customerId;
                }
    
                const params = {};
                
                if (projectId) {
                    params.projectId = projectId;
                }
                if (customerId) {
                    params.customerId = customerId;
                }
    
                const response = await axiosInstance.get(
                    "/property/config",
                    { params }
                );
                // Handle paginated response format: { items: [...], total: 1, page: 1, ... }
                let configsArray = [];
                if (response?.data?.items && Array.isArray(response.data.items)) {
                    configsArray = response.data.items;
                } else if (response?.items && Array.isArray(response.items)) {
                    configsArray = response.items;
                } else if (Array.isArray(response?.data)) {
                    configsArray = response.data;
                } else if (Array.isArray(response)) {
                    configsArray = response;
                }
    
                setConfigs(configsArray);
            } catch (error) {
                console.error("Error fetching configs:", error);
                setError(error);
                toast.error("Failed to load property configurations.");
            } finally {
                setLoading(false);
            }
        },
        [customerId, lead?.user_account?.project?.projectId, selectedProject]
    );

    useEffect(() => {
        if (customerId || selectedProject) {
            fetchConfigs();
        } else {
            setConfigs([]);
        }
    }, [customerId, selectedProject, fetchConfigs]);

    const handleScheduleAndCreate = async () => {
        setLoading(true);
        try {
            const userPayload = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                mobileNoWa: formData.mobileNoWa,
                mobileNoCalling: formData.mobileNoCalling,
                emailId: formData.emailId,
                address: {
                    buildingNo: formData.address.buildingNo,
                    streetName1: formData.address.streetName1,
                    streetName2: formData.address.streetName2,
                    city: formData.city,
                    district: formData.district,
                    pinCode: formData.pinCode,
                    state: formData.state,
                    country: formData.country,
                },
                gender: formData.gender,
                title: formData.title,
                dob: formData.dob,
                isSecondaryUser: false,
                occupation: formData.occupation,
            };

            const userResponse = await createUser(userPayload);

            const nowIso = new Date().toISOString().replace('Z', '');
            const visitData = {
                userId: userResponse.userId,
                customerId:
                    user.userInfo.loginIdentifierDetails.customer?.customerId ?? projectcustomerid,

                agentId:
                    user.userInfo.loginIdentifierDetails.customer?.customerId ??
                    user.userInfo.loginIdentifierDetails.customerId,
                propertyConfigId: Number(formData.propertyConfig),

                visited: Boolean(formData.walkIn),
            };

            if (formData.walkIn) {
                visitData.visitSchedule = null;
            } else {
                if (formData.preferredDate && formData.preferredTime) {
                    visitData.visitSchedule = `${formData.preferredDate}T${formData.preferredTime}:00`;
                }
                visitData.visitedDateTime = [nowIso];
            }

            await scheduleVisit(visitData, formData.walkIn);
            const successMessage = formData.walkIn
                ? "Walk-in visit recorded successfully!"
                : formData.preferredDate && formData.preferredTime
                ? `Visit scheduled successfully for ${formData.preferredDate} at ${formData.preferredTime}!`
                : "Visit scheduled successfully!";
            toast.success(successMessage, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            resetForm();
            setOpenDialog(false);
            if (onVisitScheduled) {
                onVisitScheduled();
            }
        } catch (error) {
            console.error("Error scheduling visit or creating user", error);
            toast.error("Failed to schedule visit. Please try again.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoading(false);
        }
    };
    const handleExistingUserSchedule = async () => {
        setLoading(true);
        try {
            let propertyConfigIdToUse;

            if (lead && lead.user_account && lead.user_account.propertyConfig && lead.user_account.propertyConfig.propertyConfigId) {
                propertyConfigIdToUse = lead.user_account.propertyConfig.propertyConfigId;
            } else {
                propertyConfigIdToUse = (flowType === "rawLead") ? newScheduleVisit.propertyConfig : formData.propertyConfig;
            }
            const assignConfigPayload = {
                customerId:  user.userInfo.loginIdentifierDetails.customer?.customerId ?? projectcustomerid,
                userId: existingUser.userId,
                personaId: 2,
                projectId: lead?.user_account?.project?.projectId || 0,  
              
                status: "OPEN",
                propertyConfigId: Number(propertyConfigIdToUse),
               
            };
             try {
                await axiosInstance.put("/customers/user", assignConfigPayload);
                
            } catch (assignConfigError) {
                console.error("Error assigning property configuration:", assignConfigError);
                toast.error("Failed to assign property configuration.");
            }
            const nowIso = new Date().toISOString().replace('Z', '');
            const visitData = {
                userId: existingUser?.userId,
                customerId:
                    user.userInfo.loginIdentifierDetails.customer?.customerId ?? projectcustomerid,

                agentId:user.userInfo.loginIdentifierDetails.customer?.customerId ??
                user.userInfo.loginIdentifierDetails.customerId,
                propertyConfigId: Number(propertyConfigIdToUse),

                visited: Boolean(formData.walkIn),
            };

            if (formData.walkIn) {
                visitData.visitSchedule = null;
            } else {
                if (formData.preferredDate && formData.preferredTime) {
                    visitData.visitSchedule = `${formData.preferredDate}T${formData.preferredTime}:00`;
                }
                visitData.visitedDateTime = [nowIso];
            }

            await scheduleVisit(visitData, formData.walkIn);

            toast.success(formData.walkIn ? "Walk-in visit recorded successfully!" : "Visit scheduled successfully!");
            resetForm();
            setOpenDialog(false);
            if (onVisitScheduled) {
                onVisitScheduled();
            }
        } catch (error) {
            console.error("Error scheduling visit for existing user", error);
            toast.error("Failed to schedule visit");
        } finally {
            setLoading(false);
        }
    };
    console.log("selectedProject", selectedProject)
    console.log("selectedProjectObject", selectedProjectObject)
 
    const handleRawLeadCreate = async () => {
        setLoading(true);
        try {
            // Validate that project is selected
            if (!selectedProject) {
                toast.error("Please select a project.");
                setLoading(false);
                return;
            }

          
                const customerId = selectedProjectObject?.customerId;
            
            const userPayload = {
                firstName: newScheduleVisit.firstName,
                lastName: newScheduleVisit.lastName,
                mobileNoCalling: newScheduleVisit.mobileNoCalling,
                mobileNoWa: newScheduleVisit.mobileNoWa,
                emailId: newScheduleVisit.emailId,
            };

            // If role is AGENT, add agentId and loginId, and also send agentId as a param
            let postUrl = `/users?customerId=${customerId}&projectId=${selectedProject}`;
            if (user.userInfo?.persona === "CHANNEL_PARTNER") {
                postUrl += `&agentId=${user.userInfo.loginIdentifierDetails.customerId}`;
            }

            const response = await axiosInstance.post(postUrl, userPayload);
             if (newScheduleVisit.propertyConfig) {
              
                const assignConfigPayload = {
                   customerId:  user.userInfo.loginIdentifierDetails.customer?.customerId ?? projectcustomerid,
                   userId:  response?.userId,
                   personaId: 2,  
                   projectId: Number(selectedProject),
                   status: "OPEN",
                   propertyConfigId: Number(newScheduleVisit.propertyConfig),
                  
               };

                try {
               await axiosInstance.put("/customers/user", assignConfigPayload);
            
           } catch (assignConfigError) {
               console.error("Error assigning property configuration:", assignConfigError);
               toast.error("Failed to assign property configuration.");
           }

            }
            // Add schedule if visit details are filled out or marked as walk-in
            const hasVisitSchedule = newScheduleVisit.preferredDate && newScheduleVisit.preferredTime;
            if ((hasVisitSchedule || newScheduleVisit.walkIn) && newScheduleVisit.propertyConfig) {
                const nowIso = new Date().toISOString().replace('Z', '');
                const visitData = {
                    userId: response?.userId,
                    customerId:
                        user.userInfo.loginIdentifierDetails.customer?.customerId ?? projectcustomerid,
                    agentId:
                        user.userInfo.loginIdentifierDetails.customer?.customerId ??
                        user.userInfo.loginIdentifierDetails.customerId,
                    propertyConfigId: Number(newScheduleVisit.propertyConfig),
                    visited: Boolean(newScheduleVisit.walkIn),
                };
                if (newScheduleVisit.walkIn) {
                    visitData.visitSchedule = null;
                } else {
                    if (hasVisitSchedule) {
                        visitData.visitSchedule = `${newScheduleVisit.preferredDate}T${newScheduleVisit.preferredTime}:00`;
                    }
                    visitData.visitedDateTime = [nowIso];
                }
                try {
                    await scheduleVisit(visitData, newScheduleVisit.walkIn);
                    toast.success(newScheduleVisit.walkIn ? "Walk-in visit recorded successfully!" : "Visit scheduled successfully!");
                }
                catch (error) {
                    toast.error("Failed to schedule visit");
                }
            }
            toast.success("Raw lead added successfully!");
            resetForm();
            setOpenDialog(false);
            if (onRawLeadCreated) {
                onRawLeadCreated();
            }
        } catch (error) {
            console.error("Error creating raw lead:", error);
            toast.error("Failed to add raw lead.");
        } finally {
            setLoading(false);
        }
    };
    const resetForm = useCallback(() => {
        setFormData({
            firstName: "",
            lastName: "",
            mobileNoWa: "",
            mobileNoCalling: "",
            emailId: "",
            address: {
                buildingNo: "",
                streetName1: "",
                streetName2: "",
                city: "",
                district: "",
                pinCode: "",
                state: "",
                country: "",
            },
            gender: "MALE",
            title: "MR",
            dob: new Date().toISOString().split("T")[0],
            preferredDate: "",
            preferredTime: "",
            propertyConfig: "",
            buildingId: "",
            isSecondaryUser: false,
            occupation: "",
            selectedProjects: [],
            walkIn: false,
        });
        setConfigs([]);
        setSelectedProject("");
        setSelectedProjectObject(null);
        setStep(0);
        if (typeof setNewScheduleVisit === "function") {
            setNewScheduleVisit((prev) => ({
                ...prev,
                preferredDate: "",
                preferredTime: "",
                propertyConfig: "",
                walkIn: false,
            }));
        }
    }, []);

    useEffect(() => {
        if (!openDialog) {
            resetForm();
        }
    }, [openDialog, resetForm]);

    const validateDateBeforeSubmit = (data) => {
        if (data?.walkIn) {
            return true;
        }

        // Date and time are optional, but if provided, validate them
        if (data?.preferredDate) {
            const selectedDate = new Date(data.preferredDate);
            const today = new Date();
            const maxDate = new Date();
            maxDate.setDate(today.getDate() + 14);
            
            // Reset time to compare only dates
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);
            maxDate.setHours(0, 0, 0, 0);
            
            if (selectedDate < today) {
                toast.error("Please select today's date or a future date.", {
                    position: "top-right",
                    autoClose: 3000,
                });
                return false;
            }
            
            if (selectedDate > maxDate) {
                toast.error("Please select a date within the next 14 days.", {
                    position: "top-right",
                    autoClose: 3000,
                });
                return false;
            }
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate date before proceeding
        let dataToValidate;
        if (flowType === "rawLead") {
            dataToValidate = newScheduleVisit;
            // Additional validation for raw lead
            if (!selectedProject) {
                toast.error("Please select a project.");
                return;
            }
        } else {
            dataToValidate = formData;
        }

        if (!validateDateBeforeSubmit(dataToValidate)) {
            return;
        }

        if ((flowType === "createUser" && step === 2) || (flowType === "scheduleVisit" && step === 1) || (flowType === "rawLead" && step === 2)) {
            if (flowType === "scheduleVisit") {
                await handleExistingUserSchedule();
            } else if (flowType === "createUser") {
                await handleScheduleAndCreate();
            } else if (flowType === "rawLead") {
                await handleRawLeadCreate();
            }
        }
    };

    const handleNext = () => {
        setStep(step + 1);
    };

    const renderSteps = () => {
        let steps;
        switch (flowType) {
            case "createUser":
                steps = stepsForCreateUser;
                break;
            case "scheduleVisit":
                steps = stepsForRegularFlow;
                break;
            case "rawLead":
                steps = stepsForRawLead;
            default:
                steps = stepsForRegularFlow;
        }
        return <ProgressBar steps={steps} currentStep={step} />;
    };


    const renderPropertyAndBuildingInfo = () => {
        return (
            <div className="flex flex-col space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="propertyConfig" className="font-medium">
                            Select Property Configuration
                        </label>
                        <select
                            name="propertyConfig"
                            value={newScheduleVisit?.propertyConfig ?? formData?.propertyConfig ?? ""}
                            onChange={(e) => handleBuildingAndConfigChange({ target: { name: "propertyConfig", value: e.target.value } })}
                            className="w-full px-2 py-2 border border-slate-300 rounded-md focus:border-flamingo-500 focus:ring-0 focus:outline-none transition-colors duration-200 bg-white text-sm mt-1"
                            required
                        >
                            <option value="">Select a configuration</option>
                            {configs
                                .filter(config => config && config.propertyConfigId !== undefined)
                                .map((config) => (
                                    <option key={config.propertyConfigId} value={config.propertyConfigId}>
                                        {config.projectPhase.project.projectName} - {config.configName}
                                    </option>
                                ))}
                        </select>
                        {loading && <Spinner />}
                        {error && <p className="text-red-500 text-sm">{error.message}</p>}
                    </div>
                </div>
            </div>
        );
    };

    const renderVisitDetails = () => {
        const data = flowType === "rawLead" ? newScheduleVisit : formData;
        const isWalkIn = Boolean(data?.walkIn);

        // Calculate min and max dates
        const today = new Date();
        const maxDate = new Date();
        maxDate.setDate(today.getDate() + 14); // 14 days from today

        const minDateString = today.toISOString().split('T')[0];
        const maxDateString = maxDate.toISOString().split('T')[0];

        return (
            <div className="flex flex-col gap-4 mt-2 mb-6">
                <label htmlFor="propertyConfig" className="font-medium">
                    Site Visit Schedule
                </label>
                <div className="flex items-center gap-2">
                    <input
                        id="walkIn"
                        type="checkbox"
                        checked={isWalkIn}
                        onChange={(e) => handleWalkInToggle(e.target.checked)}
                        className="h-4 w-4 text-flamingo-500 border-slate-300 rounded"
                    />
                    <label htmlFor="walkIn" className="text-sm text-slate-700">
                        Mark as walk-in (date and time are already optional)
                    </label>
                </div>
                <CustomInput
                    label="Preferred Date (Optional)"
                    name="preferredDate"
                    type="date"
                    value={data?.preferredDate}
                    onChange={flowType === "rawLead" ? handleRawLeadInputChange : handleInputChange}
                    min={minDateString}
                    max={maxDateString}
                    disabled={isWalkIn}
                />
                <CustomInput
                    label="Preferred Time (Optional)"
                    name="preferredTime"
                    type="time"
                    value={data?.preferredTime}
                    onChange={flowType === "rawLead" ? handleRawLeadInputChange : handleInputChange}
                    disabled={isWalkIn}
                />
                <div className="text-sm text-slate-600 mt-2">
                    {!isWalkIn ? (
                        <>
                            <p>• Date and time are optional</p>
                            <p>• If provided, date must be today or within the next 14 days</p>
                            <p>• Available dates: {minDateString} to {maxDateString}</p>
                        </>
                    ) : (
                        <p>• Walk-in selected: date and time inputs are disabled</p>
                    )}
                </div>
            </div>
        );
    };

    const renderReviewDetails = () => {
        let data;
        if (flowType === 'rawLead') {
            data = newScheduleVisit;
        } else if (flowType === 'scheduleVisit' && existingUser) {
            data = { ...existingUser, ...formData };
        } else {
            data = formData;
        }

     

        const hasAddress = data?.address && (data.address.buildingNo || data.address.streetName1 || data.address.streetName2 || data.address.city || data.address.district || data.address.state || data.address.country || data.address.pinCode);

        return (
            <div className="">
                <div className=" border rounded-lg p-4 shadow-sm">
                    <p className="font-medium text-slate-800 mb-4">
                        Review Your Details
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">

                        {data?.firstName && (
                            <div>
                                <p className="text-sm font-normal text-slate-600">
                                    Name
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data?.title} {data?.firstName} {data?.lastName}
                                </p>
                            </div>
                        )}

                        {data?.occupation && (
                            <div>
                                <p className="text-sm font-normal text-slate-600">
                                    Occupation
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data?.occupation}
                                </p>
                            </div>
                        )}

                        {data?.mobileNoWa && (
                            <div>
                                <p className="text-sm font-normal text-slate-600">
                                    WhatsApp Number
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data?.mobileNoWa}
                                </p>
                            </div>
                        )}

                        {data?.mobileNoCalling && (
                            <div>
                                <p className="text-sm font-normal text-slate-600">
                                    Contact Number
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data?.mobileNoCalling}
                                </p>
                            </div>
                        )}

                        {data?.emailId && (
                            <div>
                                <p className="text-sm font-normal text-slate-600">
                                    Email
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data?.emailId}
                                </p>
                            </div>
                        )}

                        {hasAddress && (
                            <div className="col-span-3">
                                <p className="text-sm font-normal text-slate-600">
                                    Address
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data?.address?.buildingNo ? `${data.address.buildingNo}, ` : ""}{" "}
                                    {data?.address?.streetName1 ? `${data.address.streetName1}, ` : ""}{" "}
                                    {data?.address?.streetName2 ? `${data.address.streetName2}, ` : ""}{" "}
                                    {data?.address?.city ? `${data.address.city}, ` : ""}{" "}
                                    {data?.address?.district ? `${data.address.district}, ` : ""}{" "}
                                    {data?.address?.state ? `${data.address.state}, ` : ""}{" "}
                                    {data?.address?.country ? `${data.address.country} ` : ""}{" "}
                                    {data?.address?.pinCode ? `- ${data.address.pinCode}` : ""}
                                </p>
                            </div>
                        )}

                        {data?.preferredDate && (
                            <div>
                                <p className="text-sm font-normal text-slate-600">
                                    Preferred Date
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data?.preferredDate}
                                </p>
                            </div>
                        )}

                        {data?.preferredTime && (
                            <div>
                                <p className="text-sm font-normal text-slate-600">
                                    Preferred Time
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data?.preferredTime}
                                </p>
                            </div>
                        )}

                        {typeof data?.walkIn === "boolean" && (
                            <div>
                                <p className="text-sm font-normal text-slate-600">
                                    Walk-in Visit
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {data.walkIn ? "Yes" : "No"}
                                </p>
                            </div>
                        )}

                        {flowType === "rawLead" && selectedProject && (
                            <div className="col-span-3">
                                <p className="text-sm font-normal text-slate-600">
                                    Selected Project
                                </p>
                                <p className="text-base font-medium text-slate-800">
                                    {projects.find(p => p.projectId === selectedProject)?.projectName || selectedProject}
                                </p>
                            </div>
                        )}

                    </div>
                </div>
                <div className="flex justify-center mt-4">
                    <p className="text-slate-500 text-sm">
                        Make sure all details are correct before submitting.
                    </p>
                </div>
            </div>
        );
    };

    const renderRawLeadInfo = () => (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
                <label className="font-medium block mb-3">
                    Select Project
                </label>
                
                <select
                    value={selectedProject}
                    onChange={(e) => {
                        const projectId = e.target.value;
                        setSelectedProject(projectId);
                        setNewScheduleVisit((prev) => ({ ...prev, propertyConfig: "" }));
                        setConfigs([]);
                        
                        // Find and set the selected project object
                        const projectObj = projects.find(project => project.projectId === Number(projectId));
                        setSelectedProjectObject(projectObj);
                    }}
                    className="w-full px-3 py-2 text-left border border-slate-300 rounded-md focus:border-flamingo-500 focus:ring-0 focus:outline-none transition-colors duration-200 bg-white text-sm"
                    required
                >
                    <option value="">Select a Project</option>
                    {projects.map((project) => (
                        <option key={project.projectId} value={project.projectId}>
                            {project.projectName}
                        </option>
                    ))}
                </select>
            </div>

            <CustomInput
                label="First Name"
                name="firstName"
                value={newScheduleVisit?.firstName}
                onChange={(e) =>
                    handleRawLeadInputChange({ target: { name: "firstName", value: e.target.value } })
                }
                required
            />
            <CustomInput
                label="Last Name"
                name="lastName"
                value={newScheduleVisit?.lastName}
                onChange={(e) =>
                    handleRawLeadInputChange({ target: { name: "lastName", value: e.target.value } })
                }
                required
            />
           
            <CustomInput
                label="Email"
                name="emailId"
                type="email"
                value={newScheduleVisit?.emailId}
                onChange={(e) =>
                    handleRawLeadInputChange({ target: { name: "emailId", value: e.target.value } })
                }
                required
            />
             <CustomPhoneInput
                label="Mobile No (Whatsapp)"
                name="mobileNoWa"
                value={newScheduleVisit?.mobileNoWa}
                onChange={(value) =>
                    handleRawLeadInputChange({ target: { name: "mobileNoWa", value } })
                }
                required
            />
            <CustomPhoneInput
                label="Mobile No (Call)"
                name="mobileNoCalling"
                value={newScheduleVisit?.mobileNoCalling}
                onChange={(value) =>
                    handleRawLeadInputChange({ target: { name: "mobileNoCalling", value } })
                }
                required
            />
        </div>
    );

    const renderContent = () => {
        switch (flowType) {
            case "rawLead":
                switch (step) {
                    case 0:
                        return renderRawLeadInfo();
                    case 1:
                        return renderPropertyAndBuildingInfo();
                    case 2:
                        return renderVisitDetails();
                    default:
                        return null;
                }
                break;
            case "createUser":
                switch (step) {
                    case 0:
                        return (
                            <CreateUser
                                formData={formData}
                                handleInputChange={handleInputChange}
                                occupations={occupations}
                            />
                        );
                    case 1:
                        return renderPropertyAndBuildingInfo();
                    case 2:
                        return renderVisitDetails();
                    case 3:
                        return renderReviewDetails();
                    default:
                        return null;
                }
                break;
            case "scheduleVisit":
                switch (step) {
                    case 0:
                        return renderPropertyAndBuildingInfo();
                    case 1:
                        return renderVisitDetails();
                    case 2:
                        return renderReviewDetails();
                    default:
                        return null;
                }
                break;
            default:
                return null;
        }
    };

    const getStepsForFlow = () => {
        switch (flowType) {
            case "createUser":
                return stepsForCreateUser;
            case "scheduleVisit":
                return stepsForRegularFlow;
            case "rawLead":
                return stepsForRawLead;
            default:
                return stepsForRegularFlow;
        }
    };
    useEffect(() => {
        const adjustStepBasedOnFlow = () => {
            if (flowType === "scheduleVisit" && isPropertyAssigned) {
                // Directly set the step to 1 (skipping the config selection)
                setStep(1);
            }
        };

        adjustStepBasedOnFlow(); // Call it initially when the component loads.
    }, [flowType, isPropertyAssigned]);

    return (
        <>
            {openDialog && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-50"
                    onClick={() => setOpenDialog(false)}
                />
            )}

            {openDialog && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="relative bg-white rounded-lg shadow-lg w-[90%] md:w-[50%] max-h-[90vh] mx-4 overflow-y-scroll">
                        <CloseButton className="absolute top-4 right-4" onClick={() => setOpenDialog(false)} />
                        <div className="w-full p-4">
                            <h3 className="text-xl font-semibold mb-1 text-center text-slate-800">
                                {flowType === "rawLead" ? "Add Lead" : flowType === "createUser" ? "Create User" : "Schedule Visit"}
                            </h3>

                            <div className="flex justify-center w-full m-4">
                                <div className="flex w-[90%] flex-col items-center">
                                    {renderSteps()}

                                    <div className="flex w-full max-w-4xl justify-between  text-sm font-medium text-slate-700">
                                        {(getStepsForFlow()).map((progress, index) => (
                                            <div
                                                key={index}
                                                className={`text-center cursor-pointer transition-all ${step === index
                                                    ? "text-flamingo-500 font-semibold"
                                                    : "text-slate-500"
                                                    }`}
                                            >
                                                {progress}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="mt-4">
                                {renderContent()}
                            </div>

                            <div className="flex justify-end gap-3 mt-2">
                                {flowType !== "rawLead" && step > 0 && (
                                    <OutlineButton
                                        disabled={loading}
                                        onClick={() => setStep(step - 1)}
                                        className="w-32"
                                    >
                                        Back
                                    </OutlineButton>
                                )}
                                {(flowType === "rawLead" && step > 0) && (
                                    <OutlineButton
                                        disabled={loading}
                                        onClick={() => setStep(step - 1)}
                                        className="w-32"
                                    >
                                        Back
                                    </OutlineButton>
                                )}
                                {((flowType === "createUser") && step < 2) || (flowType === "rawLead" && step < 2) || (flowType === "scheduleVisit" && step < 1) ? (
                                    <PrimaryButton
                                        disabled={loading}
                                        onClick={handleNext}
                                        className="w-32"
                                    >
                                        Next
                                    </PrimaryButton>
                                ) : null}

                                {(flowType === "scheduleVisit" && step === 1) ? (
                                    <PrimaryButton
                                        onClick={handleSubmit}
                                        className={"w-32"}
                                        disabled={loading}
                                    >
                                        {loading ? <Spinner className="h-4 w-4" /> : "Submit"}
                                    </PrimaryButton>
                                ) : null}
                                {(flowType === "createUser" && step === 2) || (flowType === "rawLead" && step === 2) ? (
                                    <PrimaryButton
                                        onClick={handleSubmit}
                                        className={"w-32"}
                                        disabled={loading || (flowType === "rawLead" && !selectedProject)}
                                    >
                                        {loading ? <Spinner className="h-4 w-4" /> : "Submit"}
                                    </PrimaryButton>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ScheduleVisit